// extracted by mini-css-extract-plugin
module.exports = {"container":"arrow-module--container--1BGbG","disabled":"arrow-module--disabled--Ork2S"};